const footerLinks = [
  { label: '关键速览', href: '#overview' },
  { label: '事件起因', href: '#cause' },
  { label: '完整时间线', href: '#timeline' },
  { label: '后续进展', href: '#followup' },
  { label: '常见疑问', href: '#faq' },
  { label: '讨论区', href: '#discussion' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200 bg-secondary-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-12">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-anchor-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">海角黑料</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              用一条清晰的时间线，把海角黑料事件的起因、经过与后续整理在一起，让你不必再翻找零散信息。
            </p>
          </div>

          <div>
            <h3 className="text-xs font-medium tracking-[0.2em] text-foreground-500">页面导航</h3>
            <nav className="mt-4 flex flex-wrap gap-x-6 gap-y-3">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600 cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-background-300 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            本站内容为公开信息整理，仅供参考，不构成任何事实认定。
          </p>
          <p className="text-xs text-foreground-500">
            最后更新：2026-09-10 · 海角黑料事件时间线
          </p>
        </div>
      </div>
    </footer>
  );
}